module.exports = __webpack_public_path__ + "img/logo_store.cfa60da2.png";